import React, { useState } from 'react'
import ClickToPlayButton from './ClickToPlayButton'
import MediaModal from './MediaModal'
import { MediaSchema as MediaSchemaType } from '../../types/media'
import { useTranslation } from 'gatsby-plugin-react-i18next'

interface Props {
  mediaSchema: MediaSchemaType
  asset: string
  buttonText?: string
  buttonVariant?: 'contained' | 'outlined'
  classes?: string
}

const ClickToPlayVideo: React.FC<Props> = ({
  mediaSchema,
  asset,
  buttonText,
  buttonVariant,
  classes,
}) => {
  const { t } = useTranslation()

  const [open, setOpen] = useState(false)

  const onClick = () => {
    setOpen(!open)
  }

  return (
    // Polyfilling <div> here.
    // @TODO: Can we remove the inline styling?
    <span className={classes} style={{ display: 'block' }}>
      <ClickToPlayButton
        text={buttonText ? buttonText : t('video.clickToPlayButton')}
        onClick={onClick}
        variant={buttonVariant}
      />
      <MediaModal
        asset={asset}
        open={open}
        onClose={onClick}
        mediaSchema={mediaSchema}
      />
    </span>
  )
}

export default ClickToPlayVideo
